import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Api 回傳值
 */
export interface ContractViewDataResp extends GeneralResp {
    contractHtml: string | null;
}

/**
 * @todo 契約1 ViewData
 */
const GetContractViewData = (): Promise<ContractViewDataResp> => {
    const url = RouteUrlList.API_ContractViewData.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, {}, config).then((res: AxiosResponse<ContractViewDataResp>) => {
        return res.data;
    });
};

export default GetContractViewData;
